module.exports = __webpack_public_path__ + "sk.svg?f90f1f09ff0f5944e1e73aa533f410f5";